export class EvalQAMultiChoice {
    constructor(data) {
        this.vetEvalAnswerListId = data.vetEvalAnswerListId
        this.vetEvalQuestionId = data.vetEvalQuestionId
        this.itemDescreeds = data.itemDescreeds
        this.sortOrder = data.sortOrder
        this.vetEvalQAChoiceId = data.vetEvalQAChoiceId
        this.isActive = data.isActive
    }
}

export class EvalAnswer {
    constructor(data) {
        this.vetEvalAnswerId = data.vetEvalAnswerId
        this.vetEvalId = data.vetEvalId
        this.vetEvalQuestionId = data.vetEvalQuestionId
        this.vetEvalAnswerListId = data.vetEvalAnswerListId
        this.vetAnswerListDescr = data.vetAnswerListDescr
        this.answer = data.answer
        this.questionDescr = data.questionDescr
        this.questionNbr = data.questionNbr
        this.multiQuestionNbr = data.multiQuestionNbr
        this.isActive = data.isActive
        this.selectionList = []
        for (var selection in data.selectionList) {
            this.selectionList.push(new EvalQAMultiChoice(selection))
        }
    }
}

export class EvalForm {
    constructor(data) {
        this.vetEvalId = data.vetEvalId
        this.appId = data.appId
        this.letterId = data.letterId
        this.applicantName = data.applicantName
        this.applicantUserId = data.applicantUserId
        this.applicantPhoneNumber = data.applicantPhoneNumber
        this.applicantEmail = data.applicantEmail
        this.evaluatorUserId = data.evaluatorUserId
        this.evaluatorPhoneNumber = data.evaluatorPhoneNumber
        this.evaluatorEmail = data.evaluatorEmail
        this.evaluatorName = data.evaluatorName
        this.evaluatorAddress = data.evaluatorAddress
        this.placeOfBusiness = data.placeOfBusiness
        this.titleOccupation = data.titleOccupation
        this.signerName = data.signerName
        this.signedDate = data.signedDate
        this.confidentialityRightsWaiver = data.confidentialityRightsWaiver
        this.waiverDate = data.waiverDate
        this.documentStatusId = data.documentStatusId
        this.documentStatus = data.documentStatus
        this.isSubmitted = data.isSubmitted
        this.qaList = []
        /*for(var qa in data.qaList) {
            this.qaList.push(new EvalAnswer(qa));
        }*/
    }
}

export class LetterForm {
    constructor(data) {
        this.letterFormId = data.letterFormId
        this.appId = data.appId
        this.letterId = data.letterId
        this.applicantName = data.applicantName
        this.applicantUserId = data.applicantUserId
        this.applicantPhoneNumber = data.applicantPhoneNumber
        this.applicantEmail = data.applicantEmail
        this.evaluatorUserId = data.evaluatorUserId
        this.evaluatorPhoneNumber = data.evaluatorPhoneNumber
        this.evaluatorEmail = data.evaluatorEmail
        this.evaluatorName = data.evaluatorName
        this.evaluatorAddress = data.evaluatorAddress
        this.placeOfBusiness = data.placeOfBusiness
        this.titleOccupation = data.titleOccupation
        this.signerName = data.signerName
        this.signedDate = data.signedDate
        this.confidentialityRightsWaiver = data.confidentialityRightsWaiver
        this.waiverDate = data.waiverDate
        this.documentStatusId = data.documentStatusId
        this.documentStatus = data.documentStatus
        this.isSubmitted = data.isSubmitted
        this.qaList = []
        /*for(var qa in data.qaList) {
            this.qaList.push(new EvalAnswer(qa));
        }*/
    }
}

export const initForm = {
    vetEvalId: 0,
    appId: 0,
    letterId: 0,
    applicantName: '',
    applicantUserId: 0,
    applicantPhoneNumber: '',
    applicantEmail: '',
    evaluatorUserId: 0,
    evaluatorPhoneNumber: '',
    evaluatorEmail: '',
    evaluatorName: '',
    evaluatorAddress: '',
    placeOfBusiness: '',
    titleOccupation: '',
    signerName: '',
    signedDate: new Date().toJSON(),
    confidentialityRightsWaiver: true,
    waiverDate: new Date().toJSON(),
    documentStatusId: 0,
    documentStatus: '',
    isSubmitted: false,
    qaList: [],
}

export const initLetterForm = {
    letterFormId: 0,
    appId: 0,
    letterId: 0,
    applicantName: '',
    applicantUserId: 0,
    applicantPhoneNumber: '',
    applicantEmail: '',
    evaluatorUserId: 0,
    evaluatorPhoneNumber: '',
    evaluatorEmail: '',
    evaluatorName: '',
    evaluatorAddress: '',
    placeOfBusiness: '',
    titleOccupation: '',
    signerName: '',
    signedDate: new Date().toJSON(),
    confidentialityRightsWaiver: true,
    waiverDate: new Date().toJSON(),
    documentStatusId: 0,
    documentStatus: '',
    isSubmitted: false,
    qaList: [],
}
